import { ProductOrBrand } from "./alternativeTypes";

export const travelProducts: ProductOrBrand[] = [
  {
    name: "Airbnb",
    ownerCountry: "US",
    categories: ["travel"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Airbnb"],
  },
  {
    name: "booking.com",
    ownerCountry: "US",
    headquarterIn: "NL",
    categories: ["travel"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Booking_Holdings"],
  },
  {
    name: "hotels.com",
    ownerCountry: "US",
    categories: ["travel"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Hotels.com"],
  },
  {
    name: "HomeToGo",
    ownerCountry: "LU",
    headquarterIn: "DE",
    categories: ["travel"],
    sourceLinks: [
      "https://www.hometogo.com",
      "https://en.wikipedia.org/wiki/HomeToGo",
    ],
  },
  {
    name: "Check24",
    ownerCountry: "DE",
    availableIn: ["DE"],
    categories: ["travel"],
    sourceLinks: ["https://de.wikipedia.org/wiki/Check24"],
  },
  //  Etraveli Group is being bought by Booking Holdings
  {
    name: "Clicktrip",
    ownerCountry: "DK",
    availableIn: [
      "DK",
      "UK",
      "UA",
      "ES",
      "PL",
      "NO",
      "FI",
      "IT",
      "FR",
      "DE",
      "NL",
      "SE",
      "TR",
    ],
    categories: ["travel"],
    sourceLinks: ["https://clicktrip.com"],
  },
  {
    name: "Holidu",
    ownerCountry: "DE",
    availableIn: [
      "DK",
      "DE",
      "AT",
      "CH",
      "AU",
      "CA",
      "UK",
      "IE",
      "ES",
      "MX",
      "BE",
      "IT",
      "NO",
      "BE",
      "NL",
      "PL",
      "PT",
      "SE",
    ],
    categories: ["travel"],
    sourceLinks: ["https://www.holidu.de"],
  },
  {
    name: "Landfolk",
    ownerCountry: "DK", //Denmark, Norway, Sweden, Germany, Italy and France, but available worldwide?
    categories: ["travel"],
    sourceLinks: ["https://landfolk.com"],
  },
  {
    name: "Apollo",
    ownerCountry: "DE",
    headquarterIn: "SE",
    availableIn: ["DK", "SE", "FI", "NO"],
    categories: ["travel"],
    sourceLinks: ["https://www.apollo.se"],
  },
  {
    name: "On the Beach",
    ownerCountry: "UK",
    availableIn: ["UK", "IE"],
    categories: ["travel"],
    sourceLinks: ["https://www.onthebeach.co.uk/"],
  },
  {
    name: "tripcentral.ca",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["travel"],
    sourceLinks: ["https://www.tripcentral.ca"],
  },
];